import styles from "./energy-flow-path.module.scss";

interface IProps {
  x: number;
  y: number;
  d: string;
  direction: "up" | "down";
  isActive?: boolean;
}

const EnergyFlowPath = (props: IProps) => {
  return (
    <svg
      className={styles.path}
      style={{ top: props.y + "px", left: props.x + "px" }}
    >
      <path
        d={props.d}
        strokeMiterlimit="10"
        fill="none"
        stroke="#CEE2FF"
        transform="translate(2 2)"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="square"
        strokeWidth="3"
        strokeDashoffset="10"
      ></path>
      <path
        d={props.d}
        strokeMiterlimit="10"
        fill="none"
        stroke="#6C9CDA"
        transform="translate(2 2)"
        strokeWidth="2"
        strokeDasharray="12"
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
      >
        <animate
          attributeName="stroke-dashoffset"
          values={
            props.isActive
              ? props.direction === "down"
                ? "100;-100"
                : "-100;100"
              : undefined
          }
          dur="3s"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
};

export default EnergyFlowPath;
